<script>
import { Line } from 'vue-chartjs';
import * as chartFormatting from '@/utilities/chart-formatting.js';
import debounce from 'lodash/debounce';

const data = [
  [
    0,
    4047,
    14061,
    40552,
    78315,
    152476,
    267702,
    399257,
    571907,
    716735,
    1055813,
    1384911,
    1740521,
    1906131,
    2550732,
    3011926,
    3446817,
    3881121
  ]
];

const firstYear = 2018;
const lastYear = 2022;
const startingQuarter = 3;
const endingQuarter = 4;

const datasetBorderColor = '';
const chartSpec = {
  labels: [],
  datasets: [
    {
      backgroundColor: '#8130d7',
      borderColor: datasetBorderColor,
      borderWidth: 1,
      data: data[0],
      pointRadius: 0,
      pointHoverRadius: 0,
      lineTension: 0.4
    }
  ]
};
const chartOptions = {
  layout: {
    padding: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }
  },
  animation: {
    easing: chartFormatting.animationEasing,
    duration: chartFormatting.animationDuration
  },
  legend: {
    display: false
  },
  tooltips: {
    enabled: false
  },
  scales: {
    yAxes: [
      {
        ticks: {
          padding: 20,
          autoSkip: true,
          beginAtZero: true,
          fontColor: '#424242',
          fontFamily: chartFormatting.labelFontFamily,
          fontSize: 14,
          lineHeight: 3,
          maxTicksLimit: 10,
          callback: function (val) { // Format the dollars on the Y-Axis
            if (val >= 1000000000) { // $x.xB
              return '$' + (val / 1000000000) + 'B';
            } else if (val >= 1000000) { // $x.xM
              return '$' + (val / 1000000) + 'M';
            } else { // $xx,xxx
              return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
          }
        },
        gridLines: {
          drawTicks: false,
          display: false
        }
      }
    ],
    xAxes: [
      {
        gridLines: {
          zeroLineColor: 'transparent'
        },
        ticks: chartFormatting.xLabelFormat
      }
    ]
  }
};

export default {
  name: 'MvpDistributionsChart',
  extends: Line,
  data: function () {
    return {
      chartSpec: chartSpec,
      chartOptions: chartOptions
    };
  },
  mounted () {
    this.resize();
    document.addEventListener('aos:in', this.aosChartEvent);
    this.handleDebouncedResize = debounce(this.resize, 50);
    window.addEventListener('resize', this.handleDebouncedResize);
  },
  beforeDestroy () {
    document.removeEventListener('aos:in', this.aosChartEvent);
    window.removeEventListener('resize', this.handleDebouncedResize);
  },
  methods: {
    aosChartEvent: function (event) {
      const eventDetail = (event.detail.detail !== undefined) ? event.detail.detail : event.detail;
      if (!eventDetail.classList.contains('chart-container-outer') ||
          !eventDetail.classList.contains('chart-container-policyholders-surplus')) return;
      document.removeEventListener('aos:in', this.aosChartEvent);
      this.render();
    },
    render: function () {
      this.renderChart(this.chartSpec, this.chartOptions);
    },
    resize: function () {
      this.chartSpec.labels = (
        chartFormatting.determineQuarterlyXLabels(
          firstYear,
          lastYear,
          startingQuarter,
          endingQuarter
        )
      );
      /* eslint-disable */
      if ($(window).width() < 400) {
        this.chartOptions.layout.padding.bottom = 120;
      } else if ($(window).width() >= 400 && $(window).width() < 500) {
        this.chartOptions.layout.padding.bottom = 180;
      } else if ($(window).width() >= 500 && $(window).width() < 600) {
        this.chartOptions.layout.padding.bottom = 325;
      } else if ($(window).width() >= 600 && $(window).width() < 750) {
        this.chartOptions.layout.padding.bottom = 375;
      } else if ($(window).width() >= 750 && $(window).width() < 1000) {
        this.chartOptions.layout.padding.bottom = 450;
      } else if ($(window).width() >= 1000) {
        this.chartOptions.layout.padding.bottom = 580;
      }
      /* eslint-enable */
      this.render();
    }
  }
};
</script>
